// removed by extract-text-webpack-plugin
module.exports = {"tag":"gn_cn","blue":"gn_go","red":"gn_gp"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Tag/styles.module.css
// module id = 1151
// module chunks = 27